import React from 'react';
import { fromPairs, map, get, isEqual } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { getLabel } from 'utils/getLabel';
import { Icon } from 'modules/icon-bank';
import { button as Button } from 'modules/button';
import { Form } from 'modules/form';

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { outboundCalls as OutboundCalls } from 'ui/views/widgets/outboundCalls';
 *
 * // render
 * <OutboundCalls propName='propValue'/>
 */
export const outboundCalls = ( props ) => {

    // field
    const title = props.title ;

    const { actions = [] } = props;

    return (
        <div className='ui-outbound-calls'>
			<div className='ui-outbound-calls__header'>

				{/* title for the modal */}
				<div className='ui-outbound-calls__header__title'>
					{ getLabel( title ) }
				</div>

				{/* close button */}
                <div className='ui-error-overlay__head__close' onClick={ () => props.closeOverlay() }>
                    <Icon name='close' width='14' height='14' fill='#ffffff' />
                </div>

			</div>

            <div className='ui-outbound-calls__body'>

                <Form
                    fields={ fromPairs( map( props.fields, ( field ) => [ field.name, field ] ) ) } // convert to object as specified by `Form` prop
                    values={ props.values } // default values
                    isValid={ false }
                    key={ props.formId }
                    onSubmit={ ( { values, isValid } ) => {

                        if( isValid ) {
                            props.onFormSubmit( {
                                category: values.category,
                                type: values.type,
                                callbackTime: values.callbackTime,
                                priority: values.priority,
                                dueDate: values.dueDate,
                                shortDescription: values.shortDescription,
                                description: values.description
                            } );
                        }

                    } }
                >
                    { ( { fields, values, /*isValid,*/ errors, onChange, onSumbit } = {} ) => {

                        return (
                            <form
                                onSubmit={ onSumbit }
                                className='ui-outbound-calls__body__form'
                            >
                                { /* fields */ }
                                { map( fields, ( field ) => {
                                    
                                    const className = classnames(
                                        'ui-outbound-calls__body__form__field',
                                        `ui-outbound-calls__body__form__field--${ field.name }`
                                    );

                                    return (
                                        <field.view
                                            className={ className }
                                            key={ field.name }
                                            name={ field.name }
                                            required={ field.required }
                                            config={ field.config }
                                            placeholder={ field.placeholder }
                                            label={ field.title }
                                            onChange={ onChange }
                                            value={ values[ field.name ] }
                                            error={ errors[ field.name ] }
                                            options={ get( props.values.options, field.options ) }
                                            mask={ field.mask }
                                        />
                                    );
                                } ) }

                                {/* button actions */}
                                <div className='ui-outbound-calls__body__actions'>
                                    { map( actions, action => {
                                        return (
                                            <Button
                                                { ...action }
                                                key={ action.name }
                                                id= { action.name }

                                                type= { 'cancel' !== action.name ? 'submit' : 'button' }

                                                // disabled={ 'cancel' !== action.name ? !isValid : false }
                                                outline={ 'cancel' === action.name ? true: false }
                                                size='large'
                                                className='ui-outbound-calls__body__actions__action'
                                                onClick = { isEqual( 'cancel', action.name ) ? () => {
                                                    props.closeOverlay();
                                                } : null }
                                            />
                                        );
                                    } ) }
                                </div>

                            </form>
                        );
                    } }
                </Form>
            </div>
           
        </div>
    );
};

// set display name
outboundCalls.displayName = 'outboundCalls';

// set default props
outboundCalls.defaultProps = {};

// prop types
outboundCalls.propTypes = {};
